import { render, staticRenderFns } from "./SearchPageCard.vue?vue&type=template&id=3754bcaf&scoped=true&"
import script from "./SearchPageCard.vue?vue&type=script&lang=js&"
export * from "./SearchPageCard.vue?vue&type=script&lang=js&"
import style0 from "./SearchPageCard.vue?vue&type=style&index=0&id=3754bcaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754bcaf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowButton: require('/vercel/path0/components/general/ArrowButton.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
